import React from 'react';
import { Typography } from '@mui/material';
import { isNil } from 'lodash';
import { useAuditScoreColor } from 'modules/audit/management/hooks/useAuditScoreColor';
import { ServiceType } from 'modules/settings/templates/main/interfaces';

export interface Props {
  number?: number;
  serviceType?: ServiceType;
}

const AuditRateCell = ({ number, serviceType }: Props) => {
  const validNumber = isNil(number) ? undefined : number;
  const color = useAuditScoreColor(validNumber, serviceType);

  return (
    <>
      {!isNil(validNumber) ? (
        <Typography color={color} sx={{ fontWeight: 'bold', fontSize: '20px' }}>
          {Number(validNumber.toFixed(2))}%
        </Typography>
      ) : (
        <strong> - </strong>
      )}
    </>
  );
};

export default AuditRateCell;
